const currencyStyle = (lang, symbol, total) => {
  if (lang === 'fr') return total + symbol;
  else return symbol + total;
};

const sleep = (ms) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

const zeroPad = (num, places) => String(num).padStart(places, '0');

function rearrangeBasedOnFirstArray(firstArray, secondArray) {
  // If the first array is empty, return the second array as it is
  if (firstArray.length === 0) {
    return secondArray;
  }

  // If the second array is empty, return an empty array
  if (secondArray.length === 0) {
    return [];
  }

  // Create a map for quick lookup of the index of each element in the first array based on the '_id' attribute
  let indexMap = new Map();
  firstArray.forEach((element, index) => indexMap.set(element, index));

  // Separate the elements of the second array into matched and extra
  let matchedElements = [];
  let extraElements = [];

  secondArray.forEach((element, index) => {
    if (indexMap.has(element._id)) {
      matchedElements.push(element);
    } else {
      extraElements.push(element);
    }
  });

  // Sort the matched elements based on the order in the first array
  matchedElements.sort((a, b) => indexMap.get(a._id) - indexMap.get(b._id));
  let fincalArray = matchedElements.concat(extraElements);
  //change idx to index of the sorted array
  fincalArray.forEach((element, index) => (element.idx = index));

  // Concatenate the sorted matched elements with the extra elements

  return fincalArray;
}

// ===== 简化版本 =====
function applyPointsDiscountToItems(orderInfo, discountAmount) {
  let remainingDiscount = discountAmount;

  // 优先从第一个商品开始扣减
  for (let i = 0; i < orderInfo.items.length && remainingDiscount > 0; i++) {
    console.log('itemsitemsitemsitemsitemsitemsitemsitems', orderInfo.items);
    const item = orderInfo.items[i];
    const itemTotal = item.soldPrice * item.quantity;
    const discountForItem = Math.min(remainingDiscount, itemTotal);
    const discountPerUnit = discountForItem / item.quantity;

    // 更新discount（累加）
    item.discount = (item.discount || 0) + discountPerUnit;
    item.discount = Math.round(item.discount * 100) / 100;

    // 更新soldPrice（减去折扣）
    item.soldPrice = Math.max(0, item.soldPrice - discountPerUnit);
    item.soldPrice = Math.round(item.soldPrice * 100) / 100;

    item.total_amount = item.soldPrice + item.tax_amount;
    item.total_amount = Math.round(item.total_amount * 100) / 100;

    remainingDiscount -= discountForItem;
  }

  return remainingDiscount; // 返回未使用的折扣
}
module.exports = {
  currencyStyle,
  sleep,
  zeroPad,
  rearrangeBasedOnFirstArray,
  applyPointsDiscountToItems,
};
